import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import "./PortfolioImage.css";
import Constants from "../Constants";
import { TweenLite, Power0 } from "gsap";

import iconVR from "../img/icon-vr.svg";
// import iconWebGL from "../img/icon-webgl.svg";

class PortfolioImage extends Component {
	state = {
		navigate: false,
	};
	handleClick = event => {
		this.setState({ navigate: true });
	};

	handleOver = event => {
		this.portfolioImage.classList.add("Hover");
	};
	handleOut = event => {
		this.portfolioImage.classList.remove("Hover");
	};

	getIcon = type => {
		let src;

		// switch (type) {
		// 	case Constants.TYPE_WEBGL:
		// 		src = iconWebGL;
		// 		break;

		// 	default:
		// 		src = iconVR;
		// 		break;
		// }

		if (type === Constants.TYPE_VR) {
			src = iconVR;
			return (
				<img className="IconType" src={src} alt={`Icon of type ${type}`} />
			);
		}

		return;
	};

	componentDidMount = () => {
		this.fadeIn();
	};

	componentDidUpdate = prevProps => {
		// console.log(`componentDidUpdate`);
		if (
			prevProps.labelsVisible === this.props.labelsVisible &&
			this.state.navigate === false
		) {
			TweenLite.set(this.portfolioImage, { opacity: 0 });
			this.fadeIn();
		}
	};

	fadeIn = () => {
		TweenLite.to(this.portfolioImage, 0.5, {
			opacity: 1,
			ease: Power0.easeInOut,
			delay: this.props.indexAll * Constants.ANIMATION_INTERVAL_DELAY,
		});
	};

	componentWillUnmount = () => {
		TweenLite.killTweensOf(this.portfolioImage);
	};

	render() {
		const { src, hero, type, name, id } = this.props.data;
		const { labelsVisible, indexAll } = this.props;

		if (this.state.navigate === true) {
			return <Redirect push to={`/${id}`} />;
		}

		return (
			<div
				onClick={this.handleClick}
				onMouseOver={this.handleOver}
				onMouseOut={this.handleOut}
				className={`PortfolioImage ${hero ? "Hero" : ""}`}
				ref={element => {
					this.portfolioImage = element;
				}}
			>
				<div
					className="Image"
					style={{
						backgroundImage: `url(${Constants.IMAGE_PATH_PREFIX + src})`,
					}}
				/>
				<div
					className={`Name ${labelsVisible === false ? "Hidden" : ""}`}
					style={{
						transitionDelay: `${Constants.ANIMATION_INTERVAL_DELAY *
							indexAll}s`,
					}}
				>
					{name}
				</div>
				{type !== "" && this.getIcon(type)}
			</div>
		);
	}
}

export default PortfolioImage;



// WEBPACK FOOTER //
// ./src/components/PortfolioImage.js